<script>
export default {
    name: 'mixed-icon',

    props: {
        name: {
            type: String,
            required: true
        },
        hover: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'white'
        },
        side_class: {
            type: String,
            required: false
        },
        main_color: {
            type: String,
            default: 'darkgray'
        },
        side_color: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },

    },

    data() {
        return {
            colors: {
                green: 'var(--icon-green)',
                red: 'var(--icon-red)',
                yellow: 'var(--icon-yellow)',
                blue: 'var(--icon-blue)',
                main: 'var(--icon-main)',
                transparent: 'var(--icon-main-transparent)',
                white: 'whitesmoke'
            }
        }
    },

    computed: {
        default_log_icons() {
            return {
                main: {
                    'user': { icon: 'fa-solid fa-users', color: this.colors.main },
                    'company': { icon: 'fa-solid fa-house', color: this.colors.main },
                    'company_licence': { icon: 'fa-solid fa-house', color: this.colors.main },
                    'company_membership': { icon: 'fa-solid fa-house', color: this.colors.main },
                    'company_development_network': { icon: 'fa-solid fa-house', color: this.colors.main },
                    'product_group': { icon: 'fa-solid fa-house', color: this.colors.main },
                    'milestone': { icon: 'fa-solid fa-house', color: this.colors.main },
                    'awards': { icon: 'fa-solid fa-house', color: this.colors.main },
                    'facility': { icon: 'fa-solid fa-house', color: this.colors.main },
                    'metric': { icon: 'fa-solid fa-magnifying-glass-chart', color: this.colors.main },
                    'survey_su1': { icon: 'fa-solid fa-square-poll-vertical', color: this.colors.main },
                    'survey_su2': { icon: 'fa-solid fa-square-poll-vertical', color: this.colors.main },
                    'report': { icon: 'fi fi-sr-memo', color: this.colors.main },
                    'document': { icon: 'fi fi-sr-folder', color: this.colors.main },
                    'process_track': { icon: 'fi fi-sr-rectangle-vertical-history', color: this.colors.main },
                    'element_section': { icon: 'fi fi-sr-memo', color: this.colors.main },
                    'sust_report_section': { icon: 'fi fi-sr-memo', color: this.colors.main },
                },
                side: {
                    'create': { icon: 'fa-solid fa-plus', color: this.colors.green },
                    'read': { icon: 'fi fi-sr-eye', color: this.colors.blue },
                    'update': { icon: 'fa-solid fa-wrench', color: this.colors.blue },
                    'delete': { icon: 'fa-solid fa-square-minus', color: this.colors.red },
                    'login': { icon: 'fa-solid fa-arrow-right-to-bracket', color: this.colors.green },
                    'logout': { icon: 'fa-solid fa-arrow-right-from-bracket', color: this.colors.red },
                    'send': { icon: 'fa-solid fa-paper-plane', color: this.colors.green },
                    'remind': { icon: 'fa-solid fa-bell', color: this.colors.yellow },
                    'complete': { icon: 'fi fi-sr-badge-check', color: this.colors.green },
                    'download': { icon: 'fi fi-sr-cloud-download-alt', color: this.colors.green },
                    'view': { icon: 'fi fi-sr-eye', color: this.colors.white },
                    'upload': { icon: 'fi fi-sr-cloud-upload-alt', color: this.colors.blue },
                    'purchase': { icon: '', color: this.colors.green },
                    'search': { icon: '', color: this.colors.transparent },
                },
            }
        },

        colorOfType() {
            const type = this.type;
            return type == 1 ? 'var(--icon-green)' 
                    : ( type == 2 ? 'var(--icon-red)' 
                    : (type == 3 ? 'var(--icon-yellow)' 
                    : (type == 4 ? 'var(--icon-blue)' 
                    : 'white')));
        },

        default_icon() {
            if (Object.prototype.hasOwnProperty.call(this.default_log_icons.main, this.name) && Object.prototype.hasOwnProperty.call(this.default_log_icons.side, this.side_class)) {
                return {
                    main: this.default_log_icons.main[this.name],
                    side: this.default_log_icons.side[this.side_class],
                }
            } 

            return null;
        },
    },

    methods: {
        handleClick(e) { // method to keep the icons' click events intact
            if (this.disabled) return;

            this.$emit('click', e);
        }
    }
}
</script>

<template>
    <div class="my-icon-container" @click="handleClick" :class="{'disabled-item': disabled}">
        <div v-if="default_icon != null" class="my-icon" :class="{'button-icon': hover, 'disabled-item': disabled}">
            <div class="main-icon">
                <i :class="default_icon.main.icon" :style="{color: disabled ? 'darkgray' : default_icon.main.color}"></i>
                <div class="side-icon" :style="{color: disabled ? 'darkgray' : default_icon.side.color}">
                    <i :class="default_icon.side.icon" :style="{color: disabled ? 'darkgray' : default_icon.side.color}"></i>
                </div>
            </div>
        </div>
        <div v-else class="my-icon" :class="{'button-icon': hover, 'disabled-item': disabled}">
            <div class="main-icon">
                <i :class="name" :style="{color: disabled ? 'darkgray' : main_color}"></i>
                <div v-if="side_class" class="side-icon" :style="{color: disabled ? 'darkgray' : (side_color == null ? colorOfType : null)}">
                    <i :class="side_class" :style="{color: disabled ? 'darkgray' : side_color}"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .my-icon {
        position: relative;
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;

        margin: 0;
        width: fit-content;
        height: fit-content;

        pointer-events: none;

        &:hover {
            cursor: default;
            filter: brightness(100%);
        }
    }
    .main-icon {
        font-size: 2em;

        & > .main-icon-color {
            color: var(--icon-main);
        }
    }
    .side-icon {
        position: absolute;
        bottom: -.25em;
        right: -.75em;

        font-size: .55em;
    }

    .button-icon {
        pointer-events: all !important;
        transition: all 100ms;
        &:hover {
            cursor: pointer;
            filter: brightness(80%);
        }
    }

    .disabled-item {
        cursor: default !important;
        pointer-events: none !important;
        &:hover {
            filter: none !important;
        }
    }

</style>